import { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const AppContext = createContext(null);
export const useApp = () => useContext(AppContext);

export function AppProvider({ children }) {
  const { user } = useAuth();
  const [companies, setCompanies] = useState([]);
  const [companyId, setCompanyId] = useState(localStorage.getItem("syncpe_company") || null);
  const [currency, setCurrency] = useState(localStorage.getItem("syncpe_currency") || "INR");
  const [categories, setCategories] = useState([]);
  const [loaded, setLoaded] = useState(false);

  const loadCompanies = async () => {
    const { data } = await api.get("/companies");
    setCompanies(data);
    if (data.length) {
      const saved = localStorage.getItem("syncpe_company");
      const valid = data.find((c) => c.id === saved);
      setCompanyId(valid ? saved : data[0].id);
    } else {
      setCompanyId(null);
    }
    setLoaded(true);
  };

  useEffect(() => {
    if (user && user.role) {
      loadCompanies();
      api.get("/meta").then(({ data }) => setCategories(data.categories)).catch(() => {});
    }
  }, [user]);

  const selectCompany = (id) => {
    setCompanyId(id);
    localStorage.setItem("syncpe_company", id);
  };
  const toggleCurrency = (c) => {
    setCurrency(c);
    localStorage.setItem("syncpe_currency", c);
  };

  const company = companies.find((c) => c.id === companyId);

  return (
    <AppContext.Provider value={{
      companies, company, companyId, selectCompany, loadCompanies,
      currency, toggleCurrency, categories, loaded,
    }}>
      {children}
    </AppContext.Provider>
  );
}
